import { Directive } from '@angular/core';
import { AbstractControl, NG_VALIDATORS, ValidationErrors, Validator } from '@angular/forms';

@Directive({
  selector: '[filterDateValidator]',
  providers: [{ provide: NG_VALIDATORS, useExisting: FilterDateValidatorDirective, multi: true }],
})
export class FilterDateValidatorDirective implements Validator {
  validate(control: AbstractControl<any, any>): ValidationErrors | null {
    return this.validator(control);
  }

  private validator = (control: AbstractControl): ValidationErrors | null => {
    const startDate = control.get('startDate');
    const endDate = control.get('endDate');

    if (startDate && endDate) {
      const dateEndDate = new Date(endDate.value);
      if (Number(new Date(startDate.value)) > Number(dateEndDate) && dateEndDate) {
        [startDate, endDate].forEach((c) => c.setErrors({ smaller: true }));
      } else {
        [startDate, endDate].forEach((c) => c.setErrors(null));
      }
    }

    return null;
  };
}
